import { useMemo } from 'react'
import { styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { BottomDrawer } from '$common/bottom-drawer'
import { t } from '$i18n'
import { PrimaryButton } from '$common/buttons'
import { CommonOnboarding } from '$logic/onboarding/types'

export interface FeatureOnbordingDialogProps {
  feature: CommonOnboarding
  isOpen?: boolean
  onClose: () => void
}

export function FeatureOnboardingDialog({
  feature,
  isOpen,
  onClose,
}: FeatureOnbordingDialogProps) {
  const features = useMemo(() => {
    return {
      [CommonOnboarding.CLASSROOM]: {
        title: t('featureOnboadringDialog.classroom.title'),
        name: t('featureOnboadringDialog.classroom.name'),
        description: t('featureOnboadringDialog.classroom.description'),
        listItems: [
          t('featureOnboadringDialog.classroom.listItems.item0'),
          t('featureOnboadringDialog.classroom.listItems.item1'),
          t('featureOnboadringDialog.classroom.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/classroom.png',
      },
      [CommonOnboarding.POLL]: {
        title: t('featureOnboadringDialog.poll.title'),
        name: t('featureOnboadringDialog.poll.name'),
        description: t('featureOnboadringDialog.poll.description'),
        listItems: [
          t('featureOnboadringDialog.poll.listItems.item0'),
          t('featureOnboadringDialog.poll.listItems.item1'),
          t('featureOnboadringDialog.poll.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/poll.png',
      },
      [CommonOnboarding.UNIT_TEST]: {
        title: t('featureOnboadringDialog.takTest.title'),
        name: t('featureOnboadringDialog.takTest.name'),
        description: t('featureOnboadringDialog.takTest.description'),
        listItems: [
          t('featureOnboadringDialog.takTest.listItems.item0'),
          t('featureOnboadringDialog.takTest.listItems.item1'),
          t('featureOnboadringDialog.takTest.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/tak-test.png',
      },
      [CommonOnboarding.HOME_WORK]: {
        title: t('featureOnboadringDialog.homeWork.title'),
        name: t('featureOnboadringDialog.homeWork.name'),
        description: t('featureOnboadringDialog.homeWork.description'),
        listItems: [
          t('featureOnboadringDialog.homeWork.listItems.item0'),
          t('featureOnboadringDialog.homeWork.listItems.item1'),
          t('featureOnboadringDialog.homeWork.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/home-work.png',
      },
      [CommonOnboarding.DESCRIPTIVE_EXAM]: {
        title: t('featureOnboadringDialog.descriptiveExam.title'),
        name: t('featureOnboadringDialog.descriptiveExam.name'),
        description: t('featureOnboadringDialog.descriptiveExam.description'),
        listItems: [
          t('featureOnboadringDialog.descriptiveExam.listItems.item0'),
          t('featureOnboadringDialog.descriptiveExam.listItems.item1'),
          t('featureOnboadringDialog.descriptiveExam.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/descriptive-exam.png',
      },
      [CommonOnboarding.POST]: {
        title: t('featureOnboadringDialog.post.title'),
        name: t('featureOnboadringDialog.post.name'),
        description: t('featureOnboadringDialog.post.description'),
        listItems: [
          t('featureOnboadringDialog.post.listItems.item0'),
          t('featureOnboadringDialog.post.listItems.item1'),
          t('featureOnboadringDialog.post.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/post.png',
      },
      [CommonOnboarding.TEST_EXAM]: {
        title: t('featureOnboadringDialog.testExam.title'),
        name: t('featureOnboadringDialog.testExam.name'),
        description: t('featureOnboadringDialog.testExam.description'),
        listItems: [
          t('featureOnboadringDialog.testExam.listItems.item0'),
          t('featureOnboadringDialog.testExam.listItems.item1'),
          t('featureOnboadringDialog.testExam.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/test-exam.png',
      },
      [CommonOnboarding.CREATE_HALL]: {
        title: t('featureOnboadringDialog.createHall.title'),
        name: t('featureOnboadringDialog.createHall.name'),
        description: t('featureOnboadringDialog.createHall.description'),
        listItems: [
          t('featureOnboadringDialog.createHall.listItems.item0'),
          t('featureOnboadringDialog.createHall.listItems.item1'),
          t('featureOnboadringDialog.createHall.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/create-hall.png',
      },
      [CommonOnboarding.CHANNEL_SETTINGS]: {
        title: t('featureOnboadringDialog.channelSettings.title'),
        name: t('featureOnboadringDialog.channelSettings.name'),
        description: t('featureOnboadringDialog.channelSettings.description'),
        listItems: [
          t('featureOnboadringDialog.channelSettings.listItems.item0'),
          t('featureOnboadringDialog.channelSettings.listItems.item1'),
          t('featureOnboadringDialog.channelSettings.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/channel-settings.png',
      },
      [CommonOnboarding.CHANNEL_PROFILE]: {
        title: t('featureOnboadringDialog.channelProfile.title'),
        name: t('featureOnboadringDialog.channelProfile.name'),
        description: t('featureOnboadringDialog.channelProfile.description'),
        listItems: [
          t('featureOnboadringDialog.channelProfile.listItems.item0'),
          t('featureOnboadringDialog.channelProfile.listItems.item1'),
          t('featureOnboadringDialog.channelProfile.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/channel-profile.png',
      },
      [CommonOnboarding.TEACHER_PLAYGROUND_CHANNEL]: {
        title: t('featureOnboadringDialog.testChannel.title'),
        name: t('featureOnboadringDialog.testChannel.name'),
        description: t('featureOnboadringDialog.testChannel.description'),
        listItems: [
          t('featureOnboadringDialog.testChannel.listItems.item0'),
          t('featureOnboadringDialog.testChannel.listItems.item1'),
          t('featureOnboadringDialog.testChannel.listItems.item2'),
        ],
        image: '/assets/images/feature-onboarding/test-channel.png',
      },
    }
  }, [])

  const featureData = useMemo(() => {
    if (feature in features) {
      return features[feature]
    }
    return undefined
  }, [feature, features])

  if (!featureData) {
    return undefined
  }

  const handleClose = () => {
    onClose()
    closeCurrentModal()
  }

  return (
    <BottomDrawer hidePuller isOpen={!!isOpen} onClose={handleClose}>
      <Image src={featureData.image} />
      <ContentContainer>
        <div>
          <Typography textAlign="center" variant="h2" color="neutral900">
            {featureData.title}
          </Typography>
          <Typography textAlign="center" variant="h2" color="secondary500">
            {featureData.name}
          </Typography>
        </div>
        <div style={{ width: '100%' }}>
          <Typography variant="paragraph2">
            {featureData.description}
          </Typography>
          <List>
            {featureData.listItems.map(item => (
              <li key={item}>
                <Typography variant="paragraph2">{item}</Typography>
              </li>
            ))}
          </List>
        </div>
        <PrimaryButton
          fullWidth
          text={t('common.close')}
          onClick={handleClose}
        />
      </ContentContainer>
    </BottomDrawer>
  )
}

const Image = styled('img')`
  width: 100%;
  object-fit: cover;
  height: 160px;
`

const ContentContainer = styled('div')`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`

const List = styled('ul')`
  list-style-type: disc;
  padding-right: 30px;
  margin-top: 0;
  margin-bottom: 0;
`
